import request from '@/config/axios'
import { useStorage } from '@/hooks/web/useStorage.ts'

const { getStorage } = useStorage()

// 配置相关
const config = {
  // 校验私聊内容敏感
  checkPrivateChatMsg: (params: any) => {
    return request.post({
      url: '/privateChat/checkPrivateChatMsg',
      data: params
    })
  },

  // 获取直播间基础设置
  getRoomConfig: (params: any) => {
    return request.get({
      url: '/room/getRoomConfig?roomId=' + params.roomId,
      data: params
    })
  },

  // 获取观看域名
  getWatchDomainAndAuthType: (params: any) => {
    return request.get({
      url: '/room/getWatchDomainAndAuthType?roomId=' + params.roomId,
      data: params
    })
  },
  // 获取服务器时间 getSystemTime
  getSystemTime: () => {
    return request.get({
      url: '/sysTime'
    })
  },

  // 获取服务器时间戳
  sysTimeLong: () => {
    return request.get({
      url: '/sysTimeLong'
    })
  },

  // 获取直播间免审词
  exemptWord: (roomId: any) => {
    return request.get({
      url: '/room/getRoomExemptWord?roomId=' + roomId
    })
  },

  // 获取敏感词
  sensitiveWord: (roomId: any) => {
    return request.get({
      url: '/room/getRoomSensitiveWord?roomId=' + roomId
    })
  },
  // 获取回放数据
  getPlayBackMessage: (params: any) => {
    return request.post({
      url: '/room/getPlaybackMessage',
      data: params
    })
  },
  // 获取最大在线人数(朱雀配置)
  checkEnter: (params: any) => {
    return request.post({ url: '/room/roomLimit', data: params })
  },
  // 报错测试
  setUrl: (url: any) => {
    return request.get({
      url: url
    })
  },
  // 通过渠道ID获取渠道名称/live/getChannelNameById
  getChannelNameById: (params: any) => {
    return request.post({
      url: '/live/getChannelNameById',
      data: params
    })
  },
  // 通过ID和type获取视频
  queryShareVideo: (params: any) => {
    return request.post({
      url: '/share/queryShareVideo',
      data: params
    })
  },

  // 获取直播间分享
  getShareConfig: (data: any) => {
    return request.post({
      url: '/wx/mp/config',
      data
    })
  }
}

// 数据上报相关
const data = {
  // 获取用户真实渠道
  queryRealChannelInfo: (params: any) => {
    return request.post({ url: '/room/queryRealChannelInfo', data: params })
  },

  // startReport/userEnter 合并接口
  enterRoom: (params: any) => {
    return request.post({ url: '/live/enterRoom', data: params })
  },

  // 新增观看记录
  startReport: (params: any) => {
    return request.post({ url: '/live/saveWatchRecord', data: params })
  },

  // 累加上报数据
  timingReport: (params: any) => {
    return request.post({ url: '/live/reportWhenLiving', data: params })
  },

  // 退出直播间（停止上报）
  endReport: (params: any) => {
    return request.post({ url: '/live/leaveRoom', data: params })
  },

  // 渠道上报
  userEnter: (data: any) => {
    return request.post({ url: '/user/room/userEnter', data })
  },

  // 答题-提交答案
  submitAnswer: (data: any) => {
    return request.post({ url: '/question/submitAnswer', data })
  },

  // 签到-用户签到
  userSign: (data: any) => {
    return request.post({ url: '/roomSign/userSign', data })
  },

  // 签到-获取用户是否需要签到
  getUserNeedSign: (data: any) => {
    return request.post({ url: '/roomSign/getUserNeedSign', data })
  },

  // 卡片-提交答案
  submitCardAnswer: (data: any) => {
    return request.post({ url: '/interactionCard/submitAnswer', data })
  },

  // IM日志上报/reportErrorLog
  reportErrorLog: (data: any) => {
    return request.post({
      url: '/reportErrorLog',
      data
    })
  },

  reportCommonLog: (message: object) => {
    return request.post({
      url: '/reportCommonLog',
      data: {
        message: JSON.stringify(message),
        roomId: getStorage('roomId')
      }
    })
  },

  lookLog: (data: any) => {
    // 视频回放上报
    return request.post({ url: '/live/lookTimeLog', data })
  },

  // 点赞上报和回调
  reportLike: (data: any) => {
    return request.post({ url: '/room/reportLike', data })
  },
  // 订单场控上报
  reportQuickProduct: (data: any) => {
    // 视频回放上报
    return request.post({ url: '/live/reportQuickProduct', data })
  },
  // 获取浏览ID
  getProductBrowseId: (data: any) => {
    return request.post({ url: '/product/browse/addBrowse', data })
  },

  // 敏感词及撤回消息上报
  addNoSendMessage: (data: any) => {
    return request.post({
      url: '/room/addNoSendMessage',
      data
    })
  },
}

// 登录相关
const login = {
  // PC 手机号登录且开启微信昵称时获取code
  getWXAuthorizeCode: (params: any) => {
    return request.get({ url: '/wx/getWXAuthorizeCode', params })
  },

  // 登录
  userLogin: (params: any) => {
    return request.post({ url: '/user/userLogin', data: params })
  },

  // 参数登录
  paramsLogin: (params: any) => {
    return request.post({ url: '/user/paramValidLogin', data: params })
  },

  // 游客登录设置昵称
  saveName: (params: any) => {
    return request.post({ url: '/user/saveName', data: params })
  },

  // 获取appid
  getAppid: (key: any) => {
    return request.get({ url: '/wx/getAppid/' + key })
  },

  // 获取PC端微信二维码
  getWxQrCode: (data: any) => {
    return request.get({ url: '/wx/getWxQrCode', params: data })
  },

  // 获取PC端微信扫码登录状态
  checkWxQrCode: (data: any) => {
    return request.get({ url: '/user/checkPCWxQrCodeLogin', params: data })
  },

  // PC端微信扫码状态提交
  saveWxQrCode: (data: any) => {
    return request.get({ url: '/wx/saveWxQrCode?code=' + data })
  },

  // PC中间授权页登录提交
  checkPCAuthorizationCode: (code: any, qrcode: any, clientId: any, onlySaveCode: boolean) => {
    return request.get({
      url: `/wx/checkPCAuthorizationCode?code=${code}&qrCode=${qrcode}&clientId=${clientId}&onlySaveCode=${onlySaveCode}`
    })
  },

  // 获取登录短信验证码
  getTourist: (data: any) => {
    return request.post({ url: '/sms/verification/get/tourist', data })
  },

  // 密码登录
  userPwdLogin: (data: any) => {
    return request.post({ url: '/user/userPwdLogin', data })
  },

  // 白名单密码登录
  checkWhitePwd: (data: any) => {
    return request.post({ url: '/user/checkWhitePwd', data })
  },

  // 手机验证码登录
  userMobileLogin: (data: any) => {
    return request.post({ url: '/user/userMobileLogin', data })
  },

  // 检验token 是否失效 && 返回用户状态
  getUserExtraInfo: (roomId: any) => {
    return request.get({ url: '/user/getUserRoomExtraInfo?roomId=' + roomId })
  },

  // 获取微信用户信息
  userWxLogin: (data: any) => {
    return request.post({ url: '/user/userWxLogin', data })
  },

  // 报名观看
  registerWatchUserInfo: (data: any) => {
    return request.post({ url: '/room/registerWatchUserInfo', data })
  },

  // 个人中心//
  // 获取个人信息
  personalInfo: (data: any) => {
    return request.post({ url: '/user/personalInfo', data })
  },
  // 获取购买记录列表
  myOrderList: (data: any) => {
    return request.post({ url: '/user/myOrderList', data })
  },
  // 获取课程列表
  myRoomList: (data: any) => {
    return request.post({ url: '/user/myRoomList', data })
  },
  // 获取订单详情信息
  orderDetail: (data: any) => {
    return request.post({ url: '/user/orderDetail', data })
  },

  // 验证 密码观看-游客登录开关关闭后 密码
  checkWatchPassword: (data: any) => {
    return request.post({ url: '/user/checkWatchPassword', data })
  }
}

// 直播间相关
const live = {
  // 获取长链key
  getWatchParamKey: (params: any) => {
    return request.post({ url: '/getWatchParamKey', data: params })
  },

  // 获取直播地址
  getPlayUrl: (params: any) => {
    return request.post({ url: '/live/getPlayUrl', data: params })
  },

  // 查询直播间最新历史消息
  getHistoryMsg: (params: any) => {
    return request.get({
      url: '/room/getRoomLatestMessage?roomId=' + params.roomId
    })
  },

  // 获取直播间累计观看人数
  getOnlineUsers: (data: any) => {
    return request.post({ url: '/live/getOnlineUsers', data })
  },

  // 申请连麦记录
  applyVoiceMic: (roomId: string) => {
    return request.post({
      url: '/live/applyVoiceConnectMic',
      data: { roomId }
    })
  }
}

// 礼物
const gift = {
  // 获取礼物列表
  getGiftList: (params: any) => {
    return request.get({
      url: '/room/getRoomGiftList?roomId=' + params.roomId,
      data: params
    })
  },

  // 用户发送礼物
  sendGift: (params: any) => {
    return request.post({ url: '/user/gift/giftReward', data: params })
  },

  // 获取礼物支付二维码
  wxnativepay: (params: any) => {
    return request.get({
      url: '/wxnativepay/enter',
      params: { ...params }
    })
  },

  // 获取礼物订单状态
  getPayStatus: (params: any) => {
    return request.get({
      url: '/getPayStatus',
      params
    })
  }
}

// 商品管理
const commodity = {
  // 获取商品列表
  getProductList: (params: any) => {
    return request.post({
      // url: "/roomProduct/listRoomProducts",
      url: '/roomProduct/listAllRoomProducts',
      data: params
    })
  },

  // 获取直播间商品配置
  getProductConfig: (params: any) => {
    return request.get({
      url: '/roomProduct/roomProductShowConfig?roomId=' + params
    })
  },

  // 提交用户信息
  collectViewerInfo: (params: any) => {
    return request.post({
      url: '/roomProduct/collectViewerInfo',
      data: params
    })
  },

  // 用户浏览直播间商品
  viewProduct: (params: any) => {
    return request.post({
      url: '/roomProduct/viewProduct',
      data: params
    })
  },

  // 获取直播间推荐商品
  getRecommendedRoomProduct: (params: any) => {
    return request.get({
      url: '/roomProduct/getRecommendedRoomProduct?roomId=' + params
    })
  },
  /**
   * 获取直播间推荐商品
   * @param params  {"roomProductId":"直播间商品id"}
   * @returns
   */
  queryProductV2Detail: (params: any) => {
    return request.post({
      url: '/roomProduct/queryProductV2',
      data: params
    })
  }
}

// 支付相关
const pay = {
  // 0元购
  zeroPay: (params: any) => {
    return request.post({
      url: '/pay/zeroPay',
      data: { ...params }
    })
  },

  // 移动端支付
  pullUpPayment: (params: any) => {
    return request.post({
      url: '/wechatpay/pullUpPayment',
      data: { ...params }
    })
  },

  // 获取PC端支付方式-微信、支付宝
  getSubType: (params: any) => {
    return request.post({
      url: '/pay/subType/list',
      data: params
    })
  },

  // 获取PC端支付方式-微信、支付宝
  getNewSubType: () => {
    return request.post({
      url: '/pay/directList',
      data: {}
    })
  },

  // 获取h5端支付方式
  getPayH5: (data: any) => {
    return request.post({
      url: '/pay/h5',
      data: { ...data }
    })
  },

  // 获取h5端支付方式
  getNewPayH5: (data: any) => {
    return request.post({
      url: '/pay/directH5',
      data: { ...data }
    })
  },

  // 关闭订单
  closeOrder: (data: any) => {
    return request.post({
      url: '/payment/order/closeOrder',
      data
    })
  }
}

// 系统消息
const systemMsg = {
  // 获取房间公告消息
  listSysMessagesInDisplay: (roomId: any) => {
    return request.post({
      url: '/room/systemMessages?roomId=' + roomId
    })
  },
  // 获取房间公告消息-新
  sysMessagesLast: (roomId: any) => {
    return request.post({
      url: 'room/sysMessagesLast?roomId=' + roomId
    })
  }
}

// 课件
const courseware = {
  listTiwFileDemoByRoomId: (roomId: any) => {
    return request.get({
      url: '/tiw/listTiwFileDemoByRoomId?roomId=' + roomId
    })
  },

  describeTranscode: (data: any) => {
    return request.post({
      url: '/tiw/describeTranscode?taskId=' + data
    })
  }
}

// 系列
const series = {
  // 获取系列列表
  sectionInfo: (data: any) => {
    return request.post({
      url: '/room/sectionInfo',
      data
    })
  },
  // 获取小节历史消息
  latestSeriesMessage: (data: any) => {
    return request.post({
      url: '/room/latestSeriesMessage',
      data
    })
  }
}

// 埋点
const point = {
  // 进入直播间
  createEnter: (data: any) => {
    return request.point_post({
      url: '/point/createEnter',
      data
    })
  },

  // 发送弹幕行为
  createSend: (data: any) => {
    return request.point_post({
      url: '/point/createSend',
      data
    })
  },

  // 点击行为
  createStay: (data: any) => {
    return request.point_post({
      url: '/point/createStay',
      data
    })
  },

  // 点击行为
  createClick: (data: any) => {
    return request.point_post({
      url: '/point/createClick',
      data
    })
  }
}

/**
 * 商品分享接口
 */
const shareCommodity = {
  // 商品详情
  productShareGetDetails: (data: any) => {
    return request.post({
      url: '/productShare/getDetails',
      data
    })
  },

  // 发送短信验证码
  productShareSms: (data: any) => {
    return request.post({
      url: '/sms/verification/get/sendByType',
      data
    })
  },

  // 手机号登录
  productSharePhoneLogin: (data: any) => {
    return request.post({
      url: '/user/phoneLogin',
      data
    })
  },

  // 微信内用户登录
  productShareUserLoginByClient: (data: any) => {
    return request.post({
      url: '/user/userLoginByClient',
      data
    })
  },

  // pc 端创建支付订单
  productShareNativepay: (data: any) => {
    return request.post({
      url: '/nativepay/enterPost',
      data: { ...data }
    })
  },

  // pc 端微信登录校验
  productShareCheckPcWxQrCodeByClient: (data: any) => {
    return request.get({
      url: '/user/checkPcWxQrCodeByClient',
      params: data
    })
  },

  /** 获取链接三级域名 */
  productShareGetWatchDomain: (data: any) => {
    return request.post({
      url: '/productShare/getWatchDomain',
      data
    })
  },

  /** token 校验接口 */
  productShareCheckToken: () => {
    return request.post({
      url: '/productShare/checkToken'
    })
  },

  /** 获取支付小票页 */
  productShareReceiptInfo: (data: any) => {
    return request.post({
      url: '/pay/receiptInfo',
      data
    })
  },
  //

  /** 判断已购买的白名单自动登录 */
  userLoginByBuyRoomIdApi: (data: any) => {
    return request.post({
      url: '/user/userLoginByBuyRoomId',
      data
    })
  }
}

/**
 * 优惠券接口
 */
const coupon = {
  // 优惠券详情
  couponGetInfo: (data: any) => {
    return request.post({
      url: '/coupon/getDetails',
      data
    })
  },

  // 获取微信授权原域名
  couponGetWatchDomain: (data: any) => {
    return request.post({
      url: '/coupon/getWatchDomain',
      data
    })
  },

  // 提交信息采集
  couponSaveInfo: (data: any) => {
    return request.post({
      url: '/coupon/saveInfo',
      data
    })
  },

  // 领取优惠券
  couponUserGet: (data: any) => {
    return request.post({
      url: '/coupon/userGet',
      data
    })
  },

  // 用户可使用优惠券列表
  couponCanUseList: () => {
    return request.post({
      url: '/couponUserRecord/canUseList'
    })
  },

  // 直播间已上架优惠券列表
  couponRoomList: (data: any) => {
    return request.post({
      url: '/roomCoupon/getOnSaleList',
      data
    })
  },

  // 获取优惠券推荐信息
  couponRecommendInfo: (data: any) => {
    return request.post({
      url: '/roomCoupon/getRecommendInfo',
      data
    })
  },

  // 获取优惠券单独链接领取状态
  couponUserReceive: (data: any) => {
    return request.post({
      url: '/couponUserRecord/userReceive',
      data
    })
  },

  // 获取直播间优惠券配置
  couponRoomConfig: (data: any) => {
    return request.post({
      url: '/roomCoupon/getConfigInfo',
      data
    })
  },

  // 个人中心订单支付
  orderRepull: (data: any) => {
    return request.post({
      url: '/payment/order/repull',
      data
    })
  }
}

/** 私聊接口 */
const privateMsg = {
  // 私聊内容
  private_list: (data: any) => {
    return request.post({
      url: '/privateChat/contentList',
      data
    })
  }
}
/**
 * 红包相关api接口
 */
const redApi = {
  // 红包--领取及状态
  redPacketReceive: (data: any) => {
    return request.post({
      url: '/redPacket/receive',
      data
    })
  },
  // 红包--未领取列表
  getNoRedReceiveList: (data: any) => {
    return request.post({
      url: '/redPacket/getNoReceiveList',
      data
    })
  },
  // 红包--领取详情及列表
  getReceiveDetailsOrList: (data: any) => {
    return request.post({
      url: '/redPacket/getReceiveDetails',
      data
    })
  },
  // 红包--提现参数获取
  getRedwithdrawParams: (data: any) => {
    return request.post({
      url: '/redPacket/withdraw',
      data
    })
  },
  // 红包--当前红包状态
  getRedReceiveStatus: (data: any) => {
    return request.post({
      url: '/redPacket/getReceiveStatus',
      data
    })
  },
  // 红包--获取当前观看奖励红包状态
  getRedReceiveStatusWatch: (data: any) => {
    return request.post({
      url: '/redPacket/task/getReceiveStatus',
      data
    })
  },
  // 红包--获取当前观看奖励红包列表
  getRedPacketListWatch: (data: any) => {
    return request.post({
      url: '/redPacket/task/getRedPacketList',
      data
    })
  },
  // 红包--获取观看奖励红包详情
  getReceiveDetails: (data: any) => {
    return request.post({
      url: '/redPacket/task/getReceiveDetails',
      data
    })
  },
  // 红包--领取观看奖励红包
  receiveRedPacket: (data: any) => {
    return request.post({
      url: '/redPacket/task/receive',
      data
    })
  },
  // 红包--提现观看奖励红包
  withdrawRedPacket: (data: any) => {
    return request.post({
      url: '/redPacket/task/withdraw',
      data
    })
  },
}

/**
 * 栏目相关api接口
 */
const columnApi = {
  // 栏目配置信息/user/column/info
  getColumnConfig: (data: any) => {
    return request.post({
      url: '/user/column/info',
      data
    })
  },
  // 栏目菜单信息 /user/column/menuList
  getColumnList: (data: any) => {
    return request.post({
      url: '/user/column/menuList',
      data
    })
  },
  // 栏目点击去观看校验
  watchColumnCheck: (data: any) => {
    return request.post({
      url: '/user/column/watchCheck',
      data
    })
  },
  // 获取总访问人数
  getUserVisitTotalByColumn: (data: any) => {
    return request.post({
      url: '/user/column/getUserVisitTotal',
      data
    })
  },
  // 栏目观看记录上报
  addUserVisitByColumn: (data: any) => {
    return request.post({
      url: '/user/column/addUserVisit',
      data
    })
  },
  // 栏目视频点击次数上报
  columnLookCountLog: (data: any) => {
    return request.post({
      url: '/live/columnLookCountLog',
      data
    })
  },
  // 移动端微信授权登录
  wxLoginForColumn: (data: any) => {
    return request.post({
      url: '/column/wxLogin',
      data
    })
  },
  // 密码校验
  pwdCheckColumn: (data: any) => {
    return request.post({
      url: '/column/pwdCheck',
      data
    })
  },
  // 账号校验
  mobileCheckColumn: (data: any) => {
    return request.post({
      url: '/column/mobileCheck',
      data
    })
  },
  //  生成图片url
  getUploadImgUrl: (data: any) => {
    return request.post({
      url: '/uploadFile',
      data,
      headersType: 'multipart/form-data'
    })
  },
  // 投诉 /room/complaint
  userComplaintApi: (data: any) => {
    return request.post({
      url: '/room/complaint',
      data
    })
  },
  // 获取红包用户领取记录
  getUserReceiveListByRoom: (data: any) => {
    return request.post({
      url: '/redPacket/getUserReceiveListByRoom',
      data
    })
  },
  // 付费白名单校验
  payWhitelistCheck: (data: any) => {
    return request.post({
      url: '/column/payWhitelistCheck',
      data
    })
  }
}

/** 抽奖相关接口 */
const prizeDraw = {
  // 领奖信息采集
  prizeDrawCommit: (data: any) => {
    return request.post({ url: '/lottery/commit', data })
  },

  // 直播间当前抽奖配置
  prizeDrawConfig: (data: any) => {
    return request.post({ url: '/lottery/config', data })
  },

  // 查看用户中奖信息
  prizeDrawGetUserLottery: (data: any) => {
    return request.post({ url: '/lottery/getUserLottery', data })
  },

  // 参与抽奖
  prizeDrawJoinDraw: (data: any) => {
    return request.post({ url: '/lottery/joinDraw', data })
  },

  // 中奖名单查询
  prizeDrawWinnerUserPage: (data: any) => {
    return request.post({ url: '/lottery/winnerUserPage', data })
  }
}

export default {
  ...prizeDraw,
  ...login,
  ...gift,
  ...live,
  ...config,
  ...data,
  ...commodity,
  ...pay,
  ...systemMsg,
  ...courseware,
  ...series,
  ...point,
  ...shareCommodity,
  ...coupon,
  ...privateMsg,
  ...redApi,
  ...columnApi
}
